import { useIsPublicPage } from "lib/routing";
import { tryDoFetch } from "lib/tryDoFetch";
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { miscSlice } from "redux/slices/miscSlice";

const SECTOR_DATA_URL = "/research/japi/content/assets/sector.json";

export const SectorSubSectorDataProvider = ({ children }) => {
  const dispatch = useDispatch();
  const isPublicPage = useIsPublicPage();

  useEffect(() => {
    async function fetchData() {
      if (isPublicPage) return;
      const data = await tryDoFetch(SECTOR_DATA_URL, null, "GET", console.error);
      const sectorData = tryParseMenu(data);
      if (sectorData) dispatch(miscSlice.actions.set({ key: "sectorData", value: sectorData }));
    }
    fetchData();
  }, [dispatch, isPublicPage]);

  return children;
};

export function tryParseMenu(data) {
  if (!data) return {};
  const en = getSubSector(data.en);
  const ja = getSubSector(data.jp);

  return { en, ja };
}

const removeDuplicates = (arr) =>
  arr?.reduce((unique, item) => (unique.includes(item) ? unique : [...unique, item]), []);

function getSubSector(data) {
  if (!data) return {};
  const dataWithKeys = {};
  Object.entries(data).forEach(([key, values]) => {
    const unique = removeDuplicates(values);
    dataWithKeys[key] = unique.map((val) => ({ key: val }));
  });
  return dataWithKeys;
}
